import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import * as keywordMapping from "../../../../static/nvestKeyMapping.json"
import { concatSeries } from "async"
import { productRenderChecker } from "../../services/helperFunctions"
import {JourneyContext} from "../../context/journeyContext"
import styled from "styled-components"
import ComponentReadMore from "../componentReadMore"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import Parser from 'html-react-parser';


SwiperCore.use([Navigation])


let selectors = [
  'myBtn',
  'myBtn1',
  'myBtn2'
]

let readMoreObj = {}


const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "CPChooseYourPlan",
  "CPOptionInBuilt",
  'CPSpouseOptionBuilt',
  "Invest4gInvestmentPlanOption"
]

const tabFormControlKey = ["CPChooseYourPlan"]
const carouselFormControlKey = ['CPCustomizePlanQuestionOne', "iSelect360CPCustomizePlanQuestionOne"]

const breakpoints = length => ({
  // when window width is <= 1023px
  1023: {
    slidesPerView: length,
    allowSlideNext: false,
    allowSlidePrev: false,
  },
  // when window width is <= 767px
  767: {
    slidesPerView: 1,
    allowSlideNext: true,
    allowSlidePrev: true,
  },
})



const RadioContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label{
      text-align: center;
    }
  }

  .card {
    border-radius: 1rem;
    padding: 2rem;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    text-align: center;
    /* height: 178px; */
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;
    min-height: 24rem;
  }

  /*Check tick start  */
  .checked{
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 2rem;
    top: 2rem;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    padding: 5px;
    &>*{
      font-size: 1.2rem;
    }
  }
    
  input:checked ~ .card .checked{
    background: #fff;
    color: #3e505d;
  }
  /*Check tick end */


  .icon-container{
    /* font-size: 3rem; */
    /* padding: 1rem; */
    span{
      /* border-radius: 50%;
      padding: 1rem; */
      
      /* background: #3e505d; */
      .hero-icon{
        /* padding-top: 8px;
        color: #fff; */
        div{
        }
      }
    }
  }

  .card-title{
    font-size:2rem;
    margin: 1rem 0;
  }

  input:checked ~ .card{
    background: ${props => props.channel === "A" ? "#3e505d" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
    background: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1{
      span{
        /* background: #fff ; */
        .hero-icon{
          /* color: #3e505d; */
          div{
            background-position-y: -92px;
          }
        }
      }
    }
    .readMoreContainer{
      color:"white"
    }
  }

  input:not(:checked) ~ .card{
    opacity: 0.5;

    .readMoreContainer{    color: #505050;}
  }
`


export default function ComponentProductSimpleRadioGroup(props) {
  const [activeTab, setActiveTab] = useState(props.data.radioComponent[0].name)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [options, setOptions] = useState({})
  const [readMoreExpandObj, setReadMoreExpandObj] = useState([false,false,false,false])
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [disableFields, setDisableFields] = useState({})

  let arr = {}

  useEffect(() => {
    if(Object.keys(sectionState.sectionData).length > 0){
      if(sectionState.sectionData[props.data.formControlKey] && (props.data.formControlKey === "CPCustomizePlanQuestionOne" || props.data.formControlKey === "iSelect360CPCustomizePlanQuestionOne"  )){
        let currentRadio = document
        .getElementById(sectionState.sectionData[props.data.formControlKey])?.querySelector("[data-active-class]")
        // console.log(currentRadio)
        if(currentRadio){
          if (sectionState.sectionData[props.data.formControlKey]) {
            let radios = arr[currentRadio.getAttribute("data-active-class")]
            radios?.forEach(radio => {
              radio.classList.remove("active")
            })
            currentRadio.classList.add("active")
          }
        }
      }
      // else{
      //   setConditionState(prev => {
      //     return ({
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
      //     })
      //   })
      // }
    }
  }, [sectionState.sectionData[props.data.formControlKey], options[props.data.formControlKey]])

  useEffect(() => {
    let optionsFromStrapi = props.data.radioComponent
    // console.log(props.nvestFilterResult, "dfdfefe")
    let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]
    let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
    if(!requiredObjectInNvestFilterResult || !optionNameInMappingJson){
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: optionsFromStrapi
        })
      })
      if (!sectionState.sectionData[props.data.formControlKey]) {
        optionsFromStrapi.map(element => {
          if (element.checked) {
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
              }
            })
          }
        })
      }else{
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
          }
        })
      }
      return 
    }
    let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
    //reverseMapping the value
    if(parentUnifiedkeyofProposalJSON){
        let reverseKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase())
        if(reverseKey){
          if(conditionState[reverseKey]){
              let newOptions = []
              requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
                  if(productRenderChecker(element.ParentUnifiedCode,conditionState[reverseKey])){
                      let option = optionsFromStrapi[index]
                      option.label = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
                      option.value = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key
                      option.checked = false
                      newOptions.push(option)
                  }
              })
              if(newOptions.length >= 1){
                if(sectionState.sectionData[props.data.formControlKey]){
                  let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
                  if(indexTobeChanged !== -1){
                    newOptions[indexTobeChanged].checked = true
                  }else{
                    if(props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion"){
                      newOptions[1].checked = true
                    }else{
                      newOptions[0].checked = true
                    }
                  }
                }else{
                  if(props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion"){
                    newOptions[1].checked = true
                  }else{
                    newOptions[0].checked = true
                  }
                }
                  
                if (!sectionState.sectionData[props.data.formControlKey]) {
                  if (sectionState.sectionId === props.sectionId) {
                    setSectionState(prev => {
                      return {
                        ...prev,
                        sectionData: {
                          ...prev.sectionData,
                          [props.data.formControlKey]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value ,
                        },
                      }
                    })
                  } else {
                    setSectionState(prev => {
                      return {
                        ...prev,
                        sectionId: props.sectionId,
                        sectionData: {
                          ...prev.sectionData,
                          [props.data.formControlKey]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value,
                        },
                      }
                    })
                  }
                  if(!conditionState[`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]){
                    setConditionState(prev => {
                      return {
                        ...prev,
                        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value,
                      }
                    })
                  }
                }else{
                  setConditionState(prev => {
                    return {
                      ...prev,
                      [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
                    }
                  })
                }
                  
              }else{
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
                  }
                })
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: ""
                    }
                  }
                })
              }
              // console.log(newOptions, "fgfg")
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: newOptions
                })
              })
          }else{
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: []
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
              }
            })
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: ""
                }
              }
            })
          }
        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
    }else{
      let newOptions = []
      requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
          let option = optionsFromStrapi[index]
          option.label = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
          option.value = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key
          option.checked = false
          newOptions.push(option)
      })
      if(newOptions.length >= 1){
          if(sectionState.sectionData[props.data.formControlKey]){
            let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
            if(indexTobeChanged !== -1){
              newOptions[indexTobeChanged].checked = true
            }else{
              if(props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion"){
                newOptions[1].checked = true
              }else{
                newOptions[0].checked = true
              }
            }
          }else{
            if(props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion"){
              newOptions[1].checked = true
            }else{
              newOptions[0].checked = true
            }
          }
          if (!sectionState.sectionData[props.data.formControlKey]) {
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value ,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value ,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: (props.data.formControlKey === "CPSpouseQuestion" || props.data.formControlKey === "CPSpouseOccupationQuestion") ? newOptions[1].value : newOptions[0].value ,
              }
            })
          }else{
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
              }
            })
          }
      }else{
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
          }
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: ""
            }
          }
        })
      }
      // console.log(newOptions, "product is null")
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: newOptions
        })
      })
    }
  }, [props.nvestFilterResult, conditionState?.[props.watchKey]])

  useEffect(() => {
    autoFill()
  }, [sectionState.sectionData[props.data.formControlKey]])

  useEffect(() => {
    if(props.sectionId === "sectionFlexiEdgeCustomizeYourPlan" && props.data.formControlKey === "FlexiCPPremiumProtectionBenefit"){
      if(conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.islifetobeAssuredandProposer"]){
        if(conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.islifetobeAssuredandProposer"] === "N"){
          setDisableFields(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: true
            })
          })
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "N",
              }
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "N",
            }
          })
        }else{
          setDisableFields(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: false
            })
          })
        }
      }
    }
    
  }, [conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.islifetobeAssuredandProposer"]])
 
  const autoFill = () => {
    console.log("function called", sectionState)
    if((props.sectionId === "CPSpouseCoverDetails" || props.sectionId === "iSelect360CPSpouseCoverDetails") && props.data.formControlKey === "CPSpouseOccupationQuestion"){

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      if(props.journeyIdFromStrapi === "iSelectJourney"){
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPSpouseCoverDetails")
      }else if(props.journeyIdFromStrapi === "ISelect360Journey"){
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      }
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPSpouseCoverDetail2")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "sumAssured")
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if(sectionState.sectionData[props.data.formControlKey] === "NW"){
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["sumAssured"]: "2500000",
            }
          })
        })
        if(props.journeyIdFromStrapi === "iSelectJourney"){
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        }
        else if(props.journeyIdFromStrapi === "ISelect360Journey"){
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "spouseSumAssuredupto50Lakhs"
        }
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9]+$/"
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
        console.log(temp, "iimp")

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })

      }
      else if(sectionState.sectionData[props.data.formControlKey] === "W")
      {
        setSectionState(prev => {
          return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["sumAssured"]: "2500000",
          }
        })
      })
      let temp = journeyState.journeySteps
      console.log(temp, "dfg")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "spouseSumAssuredIATML"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }else{
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
            }
          })
        })

        let temp = journeyState.journeySteps
        console.log(temp, "dfg")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "spouseSumAssuredIATML"
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
        console.log(temp, "iimp")
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if(props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanQuestionOne" && props.journeyIdFromStrapi === "ISelect360Journey"){
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      if(props.journeyIdFromStrapi === "ISelect360Journey"){
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
      }
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanSumAssured")

      let lookupkey = "sumAssured"
      if(sectionState.sectionData[props.data.formControlKey] === "IBTML1" || sectionState.sectionData[props.data.formControlKey] === "IBTML2"){
        lookupkey = "sumAssured15Lakhs"
      }else{
        lookupkey = "sumAssured"
      }
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = lookupkey
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  }

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })

    // let selectors = [
    //   '#myBtn',
    //   '#myBtn1',
    //   '#myBtn2'
    // ]

    // let readMoreObj = {}
    // selectors.forEach((i,index)=>{

    //   readMoreObj[`el${index}`] = {element:document.querySelector(i)}

    //   if(readMoreObj[`el${index}`].element) {
    //       let parent = readMoreObj[`el${index}`].element.parentElement
    //       if(parent){
    //         readMoreObj[`dots${index}`] = parent?.querySelector(`#dots${index>0?index:''}`)
    //         readMoreObj[`more${index}`] = parent?.querySelector(`#more${index>0?index:''}`)
    //         readMoreObj[`readMoreContent${index}`] = parent?.querySelector(`.readmore-content${index>0?index:''}`)
    //       }   
    //   }
    // })

    // selectors.forEach((i,index)=>{
    //   if(readMoreObj[`el${index}`].element) {
    //     readMoreObj[`el${index}`].element?.addEventListener('click',(e)=>{
    //       let tempArr = readMoreExpandObj
    //       tempArr[index]=!readMoreExpandObj[index]
    //       setReadMoreExpandObj((prev)=>{
    //         return tempArr
    //       })
          

    //         readMoreObj[`more${index}`].style.display = readMoreExpandObj[index]? "block" :"none"
    //         readMoreObj[`el${index}`].element.textContent =  readMoreExpandObj[index] ? "Read less":'Read more'
    //         readMoreObj[`dots${index}`].style.display = readMoreExpandObj[index]? "none" :"block"  
    //     })
    //   }
    // })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

  const handleEnter = (event1,event2,isCard) =>{
    if(event1.key == 'Enter'){
      handleChange(event2,isCard)
    }
  }



  const handleChange = ({ target }, isCard, e) => {
    // e.preventDefault()
    // console.log("inside ", target)
    if(disableFields[props.data.formControlKey]){
      return
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })

    props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    // if(!selectors.includes(e.target.id ?? '')){
    // }

    // if (target.value && isCard) {
    //   // console.log(target.value)
    //   // console.log(target.value);
    //   // smoke-white-clr
    //   // console.log(target.parentElement.parentElement.parentElement)

    //   // radio-cards by Id
    //   let currentRadio = document
    //     .getElementById(target.value)
    //     .querySelector("[data-active-class]")
    //   // console.log(currentRadio)
    //   // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

    //   // removing other active class
    //   let radios = arr[currentRadio.getAttribute("data-active-class")]
    //   radios?.forEach(radio => {
    //     radio.classList.remove("active")
    //   })

    //   // activate radio Radio
    //   currentRadio.classList.add("active")
    // }

    // console.log(sectionState, "section state")
    // console.log(conditionState, "condition state")
  }

  
  const handleChangeSimpleRadio = ({ target }, isCard) => {
    // console.log("inside ", target)

    if(disableFields[props.data.formControlKey]){
      return
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    
    if(!selectors.includes(target.id ?? '')){
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }

  }
  return (options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 ?
    <div className={`field ${props.elementClass}`} key={props.sectionId + props.indexForKey}>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }
        
        `}
      </style>
      {radioCardFormControlKey.includes(props.data.formControlKey) ? (
        <>
          <p className="text-left plan-heading new-heading-font">
          {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
        {props.data.tooltip &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                props.data.tooltip
                              )))}
                            </span>
                          </span>
                        }
          </p>

          {carouselFormControlKey.includes(props.data.formControlKey) ? (
            <div className="row radio-card-container">
              {/* <Swiper
                navigation={true}
                autoplay={true}
                breakpoints={breakpoints(props.data.radioComponent?.length ?? 0)}
              > */}
                {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 && options[props.data.formControlKey].map((element, i) => {
                  return (
                    // <SwiperSlide>
                      <RadioContainer channel={props.channel} className={`${element.class}`} >
                        <div >
                          <label className="width" onKeyPress={(e)=>handleEnter(e,{ target: { value: element.value } }, true)} tabIndex="0">
                            {/* <p className="radio-label" >{ element.label  }</p> */}
                            <input
                              type={element.type}
                              checked={sectionState.sectionData[props.data.formControlKey]
                                ? sectionState.sectionData[
                                    props.data.formControlKey
                                  ] === element.value
                                : element.checked
                              }
                              name={element.name}
                              value={element.value}
                              hidden
                            />
                            <div data-active-class="smoke-white-clr" className="provider card" >
                              <div className="checked" aria-hidden="true"  onClick={(e)=>handleChange({ target: { value: element.value } }, true, e)}  >
                                <FaCheck/>
                              </div>
                              <div className="icon-container-1 icon-container" aria-hidden="true" onClick={(e)=>handleChange({ target: { value: element.value } }, true, e)} >
                                <span>
                                  <div className="hero-icon" dangerouslySetInnerHTML={{ __html: element.iconHTML}}>
                                  </div>
                                </span>
                              </div>
                              <p className="card-title" >{(getValueFromJourney(
                                                              journeyState.lookup.label,
                                                              element.label
                                                            )) || element.label}</p>
                              <span style={{
                                fontSize:'1.2rem'
                              }} >  
                              {
                                (props.data.formControlKey == "CPCustomizePlanQuestionOne" || props.data.formControlKey === "iSelect360CPCustomizePlanQuestionOne" )?
                              <div className="readMoreContainer" >
                                <ComponentReadMore html={element.html} index={i} style={{color:"inherit"}}/>
                              </div>

                                :null
                              }
                              </span>
                            </div>
                          </label>
                        </div>
                      </RadioContainer>
                    // </SwiperSlide>
                  )
                })}
              {/* </Swiper> */}
            </div>
          ) : (
            <div className="row radio-card-container ">
              {tabFormControlKey.includes(props.data.formControlKey) ? (
                <div className="radio-tab hidden-lg hidden-md hidden-sm ">
                  {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 && options[props.data.formControlKey].map((el, i) => {
                    if (el.label) {
                      return (
                        <div
                          className={`${
                            props.data.radioComponent[0].name == el.name
                              ? "active-tab"
                              : ""
                          }`}
                        >
                          <p
                            data-active-tab={el.value}
                            aria-hidden="true"
                            onClick={e => handleActiveTab(e, el.name)}
                            className="text-center"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {lineCapital(getValueFromJourney(
                              journeyState.lookup.label,
                              el.label
                            )) || el.label}
                          </p>
                        </div>
                      )
                    }
                  })}
                </div>
              ) : null}
              {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 && options[props.data.formControlKey].map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    aria-hidden="true"
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                        : element.checked
                    }
                    onClick={e =>
                      handleChange({ target: { value: element.value } }, true, e)
                    }
                  >
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                        {lineCapital(getValueFromJourney(
                            journeyState.lookup.label,
                            element.label
                          )) || element.label}
                      </p>
                    ) : null}
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: element.html }}
                        className={activeTab == element.name ? "" : "hidden-xs"}
                      />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: element.html }} />
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="form-group">
            {props.data.formControlKey === "CPCustomizePlanQuestionThree" && console.log(options, sectionState.sectionData[props.data.formControlKey],conditionState, "effrfgrg")}
            {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 &&
            <div className="radio-section-design">
              <p>{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
              {props.data.tooltip &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                props.data.tooltip
                              )))}
                            </span>
                          </span>
                        }
              </p>
            </div>
            }
            {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 && options[props.data.formControlKey].map((element, i) => {
              return (
                <div className="radio-line radio-design" key={i}>
                  <label className="customradio">
                    <span className="radiotextsty inp-label">{lineCapital(getValueFromJourney(
                                                                  journeyState.lookup.label,
                                                                  element.label
                                                                )) || element.label}
                        {element.tooltip && 
                        <span style={{ marginLeft:"10px" } } className="tooltip-col text-tool-tip-design existing-tool-tip">
                          <div className="tool">i</div>
                          <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list "  style={{ width:"22rem",height:"fit-content",top:"auto",pointerEvents:"none" }}>
                            {Parser(element.tooltip)}
                          </span>
                        </span>
                        }
                    </span>
                    <input
                      type={element.type}
                      name={element.name}
                      id={element.value}
                      value={element.value}
                      checked={
                        sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                              props.data.formControlKey
                            ] === element.value
                          : element.checked
                      }
                      onChange={handleChangeSimpleRadio}
                    />
                    <span className="provider checkmark" tabIndex="0" onKeyPress={(e)=>handleEnter(e,{target:{value:element.value}},false)} > </span>
                  </label>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
    :
    <>
    </>
  )
}
